import request from '../untils/request';

export const operationSupportApi = params => {
  return request({
    url: '/operation/support-class/index',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operationComplainListApi = params => {
  return request({
    url: '/operation/complain/index',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operationComplainDetailApi = params => {
  return request({
    url: '/operation/complain/detail',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const operationComplainOperateApi = params => {
  return request({
    url: '/operation/complain/operate',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const complainFeedEditApi = params => {
  return request({
    url: '/operation/support-class/save',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};

export const complainOperateApi = params => {
  return request({
    url: '/operation/support-class/operate',
    authCode: 'SUPPORT_INDEX',
    params,
  });
};